import React from 'react';
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {IArenaGameFiltersCategoryEditorViewModel} from '../../../../services/games-filter/arena-filters/categories/arena-game-filters-category-editor-view-model.interface';
import {observer} from 'mobx-react';
import {FilterCategoryBox} from "./boxes/filter-category.box";
import {FilterCategoryContentComponent} from "./filter-category-content.component";
import {FilterCategoryHeaderComponent} from "./filter-category-header.component";

interface IFilterCategoryComponentProps {
    category: IArenaGameFiltersCategoryEditorViewModel;
    onCategoryToggle: (category: IArenaGameFiltersCategoryEditorViewModel) => void;
    isOpen: boolean;
}

export const FilterCategoryComponent = observer(
    class FilterCategoryComponent extends OrbitComponent<IFilterCategoryComponentProps> {

        render() {
            const {category, isOpen} = this.props;
            return (
                <FilterCategoryBox>
                    <FilterCategoryHeaderComponent category={category} isOpen={isOpen} onCategoryToggle={this.props.onCategoryToggle}/>
                    <FilterCategoryContentComponent category={category} isOpen={isOpen}/>
                </FilterCategoryBox>
            );
        }
    }
);
